<template>
    <div class="flex">
        <div class="flex-1">
            <label for="first_name" class="sr-only">Phone Number</label>
            <the-mask
                :mask="'(###) ###-####'"
                v-model="actualNumber"
                :placeholder="'Your mobile phone number'"
                :type="'tel'"
                name="phone_number"
                id="phone_number"
                :class="`py-3 px-4 rounded bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 relative block w-full rounded-md bg-transparent focus:z-10 sm:text-sm border-gray-300 placeholder-gray-300`"/>
        </div>
    </div>
</template>

<script>
    import {TheMask} from 'vue-the-mask';

    export default {
        props: ['number'],

        components: {TheMask},

        mounted() {
            this.actualNumber = this.number;
        },

        watch: {
            actualNumber (actualNumber, oldActualNumber) {
                if (actualNumber !== oldActualNumber) {
                    this.$emit('update:number', actualNumber);
                }
            }
        },

        data() {
            return {
                actualNumber: ''
            }
        }
    }
</script>
